import React from 'react';
import PropTypes from 'prop-types';
import {
    affIds,
    BET,
    buildTransferLink,
    dcmpTags
} from '../../helpers/transfers';
import * as Styled from './style';
import { useAuth } from '../../hooks/useAuth';

export const BetPromo = ({ promotionsConfig }) => {
    const { authStore } = useAuth();

    if (!promotionsConfig || !promotionsConfig.enabled) {
        return null;
    }

    const transferLink = buildTransferLink({
        to: BET,
        dcmp: dcmpTags.promo,
        affId: affIds.promo,
        event: promotionsConfig.eventPath,
        isLoggedIn: authStore.loggedIn
    });

    return (
        <>
            <Styled.PromoLink href={transferLink}>
                <Styled.MobileImage src={promotionsConfig.img.mobile} />
            </Styled.PromoLink>
            <Styled.PromoLink href={transferLink}>
                <Styled.DesktopImage src={promotionsConfig.img.desktop} />
            </Styled.PromoLink>
        </>
    );
};

BetPromo.propTypes = {
    promotionsConfig: PropTypes.shape({
        enabled: PropTypes.bool,
        eventPath: PropTypes.string,
        img: PropTypes.shape({
            mobile: PropTypes.string,
            desktop: PropTypes.string
        })
    }).isRequired
};

export default BetPromo;
